import * as R from "ramda";
export const roundWithPrecision = (value: number, precision: number) => {
  if (R.isNil(value) || R.isNil(precision)) return undefined;
  const base = Math.pow(10, precision);
  return Math.round(value * base) / base;
};
